const translationSRB = {
    generalData: 'Opšti podaci',
    name: 'Ime',
    nameParam: 'Ime',
    date: 'Datum',
    phoneNumber: 'Telefon',
    patientGeneralData: 'Opšti podaci o pacijentu',
    detailData: 'Detaljni podaci',
    feetMeasurement: 'Merenje stopala',
    overview: 'Pregled merenja',
    firstNameRequired: 'Ime je obavezno',
    firstName: 'Ime',
    lastName: 'Prezime',
    identityId: 'Broj Lične Karte',
    emailLabel: 'E-mail',
    phoneNumber1: 'Br.Telefona 1',
    phoneNumber2: 'Br.Telefona 2',
    gender: 'Pol',
    selectGender: 'Birajte Pol',
    male: 'Muški',
    female: 'Ženski',
    dateofBirth: 'Datum Rođenja',
    birthDateRequired: 'Datum Rođenja je obavezan',
    height: 'Visina',
    weight: 'Težina',
    shoeSize: 'Broj cipela',
    euShoeSize: 'EU Broj Cipela',
    rightHanded: 'Desnoruk',
    leftHanded: 'Levoruk',
    controlExamSchedule: 'Raspored kontrolnih pregleda',
    ekovelReport: 'Ekovel Izveštaj',
    generalExamination: 'Opšti pregled',
    optimalWeight: 'Optimalna težina',
    feetParametes: 'Parametri Stopala',
    role: 'Rola',
    displayName: 'Ime Korisnika',
    userName: 'Korisničko ime',
    organization: 'Organizacija',
    active: 'Aktivan',
    deleteConfirmation: 'Potrvdi Brisanje',
    areYouSureToDelete: 'Da li ste sigurni da zelite da obrišete korisnika',
    delete: 'Obriši',
    cancel: 'Odbaci',
    deactivate: 'Deaktiviraj',
    activate: 'Aktiviraj',
    activateUser: 'Aktiviraj korisnika',
    deactivateConfirmation: 'Potrvdi Deaktivaciju',
    areYouSureDeactivate: 'Da li ste sigurni da želite da deaktivirate korisnika',
    areYouSureActivate: 'Da li ste sigurni da želite da Aktivirate korisnika',
    updateSerialNumber: 'Ažurirajte serijski broj',
    areYouSureToDeleteUser: 'Da li ste sigurni da želite obrisati korisnika',
    actions: 'Akcije korisnika',
    parameter: 'Parametar',
    value: 'Vrednost',
    ekovelStepCorrectsize: 'Ekovel Step Correct veličina',
    initialHeight: 'Inicijalna visina',
    optimalHeight: 'Optimalna visina',
    firstCheck: 'Prvi pregled',
    secondCheck: 'Drugi pregled',
    thirdCheck: 'Treći pregled',
    therapy: 'Terapija',
    leftFoot: 'Levo stopalo',
    rightFoot: 'Desno stopalo',
    serialNumber: 'Serijski broj',
    footLength: 'Dužina stopala (mm)',
    footWidth: 'Širina stopala (mm)',
    left: 'Levo',
    right: 'Desno',
    back: 'Nazad',
    finish: 'Kraj',
    next: 'Dalje',
    selectLeg: 'Izaberite nogu',
    legLengthDifference:'Razlika u dužini nogu',
    adjustmentInterval: 'Interval podešavanja',
    adjustmentPeriod: 'Period podešavanja PP',
    week: 'Nedelja',
    weeks: 'sedmica',
    serialNumberDate: 'Datum serijskog broja',
    checkExaminationSchedule: 'Raspored kontrolnih pregleda',
    escSize: 'ESC veličina',
    saveAndOpenReport: 'Sačuvaj i otvori izveštaj',
    create: 'Dodaj korisnika',
    noRowsToShowPatients: 'Nema unetih pacijenata',
    DepthOfFootArch: 'Dubina svoda stopala (mm)*',
    DegreeOfTendon: 'Položaj tetiva (mm):',
    LegLengthDifference: 'Razlika u dužini nogu:',
    FootprintSplit: 'Prekid oslonca:',
    FootParamDescription: 'Parametri stopala',
    report: 'Izveštaj',
    examinationDate: 'Datum pregleda',
    leftFootMeasurement: 'Merenja levog stopala',
    rightFootMeasurement: 'Merenja desnog stopala',
    footParametersLeft: 'Parametri levog stopala',
    footParametersRight: 'Parametri desnog stopala',
    optimalMlaDepth: 'Optimalna dubina svoda',
    optimalMlaHeight: 'Optimal visina svoda',
    mlaDescendingLevel: 'MLA Opadajući nivo',
    mlaDescending: 'MLA Opadajuće',
    tendonPosition: 'Pozicija tetive',
    legAlignement: 'Poravnanje nogu',
    and: 'i',
    selectedLeg: 'Izabrana noga',
    allAdmins: 'ADMINI',
    allUsers: 'KORISNICI',
    allPatients: 'PACIJENTI',
    therapyDuration: 'Trajanje terapije',
    medialArchDisplacement: 'SPUŠTENOST STOPALA',
    verticalDisplacement: 'Spuštenost svoda',
    horizontalDisplacement: 'Spuštenost svoda',
    displacementPoourcentage: 'Spuštenost svoda',
    displacementLevel: 'Stepen spuštenosti',
    medialArchDepth: 'Dubina svoda X [mm]',
    medialArchHeight: 'Visina svoda Y [mm]',
    tendonBendingDegree: 'Stepen iskrivljenosti tetiva T',
    medialArchOptimalDepth: 'Optimalna dubina svoda Xo [mm]',
    medialArchOptimalHeight: 'Optimalna visina svoda Yo [mm]',
    backToPatientsList: 'Povratak na formu',
    allStepsAreDone: 'Svi koraci su završeni',
    user: 'Korisnik',
    yes: 'Da',
    no: 'Ne',
    selectAlignment: 'Zakrivljenost tetiva',
    createAdmin: 'Registracija Admina/korisnika',
    createSubAdmin: 'Registracija SubAdmina',
    createUser: 'Registracija Korisnika',
    createPatient: 'Dodavanje pacijenta',
    editPatient: 'Izmena podataka pacijenta',
    serialNumberSucces: 'Serijski broj uspešno ažuriran',
    noRowsToShow: 'Nema rezultata u listi',
    admittedBy: 'Primio',
    logout: 'Izloguj se',
    search: 'pretraga',
    suborganization: 'Podorganizacija',
    town: 'Grad',
    userSuccess: "Uspešno kreirano",
    emailAlreadyExist: "Greška: Email već postoji",
    loginErroMEssage: 'Korisničko ime ili lozinka su netačni.',
    accept: 'Prihvatam',

      // Privacy Policy Text
  privacyPolicy: 'Politika privatnosti',
  lastUpdated: 'Datum poslednje izmene: 03.04.2025',
  privacyPolicyIntro: 'Dobrodošli u aplikaciju firme Ekovel. Posvećeni smo zaštiti vaše privatnosti i bezbednosti vaših ličnih podataka. Ova Politika privatnosti objašnjava koje podatke prikupljamo, kako ih koristimo i kako ih čuvamo.',
  dataCollectionTitle: '1. PRIKUPLJANJE PODATAKA',
  personalData: 'Lični podaci pacijenata: ime, prezime, datum rođenja, kontakt informacije.',
  therapyData: 'Podaci o terapiji: medicinski nalazi, preporučeni tretmani, podaci o ortopedskim ulošcima.',
  technicalData: 'Tehnički podaci: informacije o uređaju, IP adresa, podaci o korišćenju aplikacije.',
  dataUsageTitle: '2. KORIŠĆENJE PODATAKA',
  dataUsage1: 'Vođenje evidencije pacijenata i njihovih terapija.',
  dataUsage2: 'Izrada i prilagođavanje ortopedskih uloška.',
  dataUsage3: 'Poboljšanje kvaliteta usluge i funkcionalnosti aplikacije.',
  dataUsage4: 'Ispunjavanje zakonskih i regulatornih obaveza.',
  dataStorageTitle: '3. ČUVANJE I ZAŠTITA PODATAKA',
  dataProtection: 'Vaši podaci se čuvaju na sigurnim serverima sa ograničenim pristupom i zaštićeni su odgovarajućim sigurnosnim merama. Pristup podacima imaju samo ovlašćene osobe i podaci se ne dele sa trećim licima bez vaše saglasnosti, osim kada je to zakonski obavezno.',
  userRightsTitle: '4. PRAVA KORISNIKA',
  userRights1: 'Pristupite svojim podacima.',
  userRights2: 'Zatražite ispravku netačnih podataka.',
  userRights3: 'Zatražite brisanje podataka kada više nisu potrebni.',
  userRights4: 'Povučete saglasnost za obradu podataka.',
  contactRights: 'Za ostvarivanje svojih prava, kontaktirajte nas putem ekovelcentar@gmail.com',
  privacyPolicyAcceptanceTitle: '5. PRIHVATANJE POLITIKE PRIVATNOSTI',
  privacyPolicyAcceptance: 'Korišćenjem ove aplikacije, korisnici potvrđuju da su pročitali, razumeli i saglasni su sa Politikom privatnosti. Pri prvom pokretanju aplikacije, biće im prikazana ova Politika privatnosti, a nastavak korišćenja aplikacije biće moguć tek nakon što kliknu na dugme "Slažem se".',
  contactTitle: '6. KONTAKT',
  contactIntro: 'Ako imate bilo kakva pitanja u vezi sa ovom Politikom privatnosti, možete nas kontaktirati na:',
  companyName: 'EKOVEL CENTAR DOO',
  companyAddress: 'Ugrinovački put 104, 11080, Beograd (Zemun), Srbija',
  companyEmail: 'Email: ekovelcentar@gmail.com',
  companyPhone: 'Telefon: 0113774750',
  policyUpdateNotice: 'Zadržavamo pravo da povremeno ažuriramo ovu Politiku privatnosti. O svim izmenama bićete blagovremeno obavešteni putem aplikacije.',
}

export { translationSRB }